import R from 'ramda'

// Mapping form triggers to widget triggers

import {
  isHashtagFormTrigger,
  convertHashtagFormTriggerToWidgetTrigger
} from './form-to-widget/hashtag'
import {
  isKeywordFormTrigger,
  convertKeywordFormTriggerToWidgetTrigger
} from './form-to-widget/keyword'
import {
  isOnlyFormTrigger,
  convertOnlyFormTriggerToWidgetTrigger
} from './form-to-widget/only'
import {
  isReactionFormTrigger,
  convertReactionFormTriggerToWidgetTrigger
} from './form-to-widget/reaction'
import {
  isCommentsOnFormTrigger,
  convertCommentsOnFormTriggerToWidgetTrigger
} from './form-to-widget/comments-on-post'
import {
  isReactionOnFormTrigger,
  convertReactionOnFormTriggerToWidgetTrigger
} from './form-to-widget/reaction-on'

import {
  isConsentFormTrigger,
  convertConsentFormTriggerToWidgetTrigger
} from './form-to-widget/received-onetime-consent'

import {
  isRecurringConsentFormTrigger,
  convertRecurringConsentFormTriggerToWidgetTrigger
} from './form-to-widget/received-recurring-consent'

import {
  isTimestampFormTrigger,
  convertTimestampFormTriggerToWidgetTrigger
} from '../common-triggers/form-to-widget/timestamp'

// Mapping widget triggers to form triggers

import {
  isHashtagWidgetTrigger,
  convertHashtagWidgetTriggerToFormTrigger
} from './widget-to-form/hashtag'
import {
  isKeywordWidgetTrigger,
  convertKeywordWidgetTriggerToFormTrigger
} from './widget-to-form/keyword'
import {
  isOnlyWidgetTrigger,
  convertOnlyWidgetTriggerToFormTrigger
} from './widget-to-form/only'
import {
  isReactionWidgetTrigger,
  convertReactionWidgetTriggerToFormTrigger
} from './widget-to-form/reaction'
import {
  isCommentsOnWidgetTrigger,
  convertCommentsOnWidgetTriggerToFormTrigger
} from './widget-to-form/comments-on'
import {
  isReactionOnWidgetTrigger,
  convertReactionOnWidgetTriggerToFormTrigger
} from './widget-to-form/reaction-on'

import {
  isOneTimeConsentWidgetTrigger,
  convertOneTimeConsentWidgetTriggerToFormTrigger
} from './widget-to-form/received-onetime-consent'

import {
  isRecurringConsentWidgetTrigger,
  convertRecurringConsentWidgetTriggerToFormTrigger
} from './widget-to-form/received-recurring-consent'

import {
  isTimestampWidgetTrigger,
  convertTimestampWidgetTriggerToFormTrigger
} from '../common-triggers/widget-to-form/timestamp'

const mapFacebookFormTriggersToWidgetTriggers = R.map(
  R.cond([
    [isHashtagFormTrigger, convertHashtagFormTriggerToWidgetTrigger],
    [isKeywordFormTrigger, convertKeywordFormTriggerToWidgetTrigger],
    [isReactionFormTrigger, convertReactionFormTriggerToWidgetTrigger],
    [isOnlyFormTrigger, convertOnlyFormTriggerToWidgetTrigger],
    [isCommentsOnFormTrigger, convertCommentsOnFormTriggerToWidgetTrigger],
    [isReactionOnFormTrigger, convertReactionOnFormTriggerToWidgetTrigger],
    [isConsentFormTrigger, convertConsentFormTriggerToWidgetTrigger],
    [
      isRecurringConsentFormTrigger,
      convertRecurringConsentFormTriggerToWidgetTrigger
    ],
    [isTimestampFormTrigger, convertTimestampFormTriggerToWidgetTrigger],
    [R.T, R.identity]
  ])
)

const mapFacebookWidgetTriggersToFormTriggers = R.pipe(
  R.map(
    R.cond([
      [isHashtagWidgetTrigger, convertHashtagWidgetTriggerToFormTrigger],
      [isKeywordWidgetTrigger, convertKeywordWidgetTriggerToFormTrigger],
      [isReactionWidgetTrigger, convertReactionWidgetTriggerToFormTrigger],
      [isOnlyWidgetTrigger, convertOnlyWidgetTriggerToFormTrigger],
      [isCommentsOnWidgetTrigger, convertCommentsOnWidgetTriggerToFormTrigger],
      [isReactionOnWidgetTrigger, convertReactionOnWidgetTriggerToFormTrigger],
      [
        isOneTimeConsentWidgetTrigger,
        convertOneTimeConsentWidgetTriggerToFormTrigger
      ],
      [
        isRecurringConsentWidgetTrigger,
        convertRecurringConsentWidgetTriggerToFormTrigger
      ],
      [isTimestampWidgetTrigger, convertTimestampWidgetTriggerToFormTrigger],
      [R.T, R.identity]
    ])
  )
)

export {
  mapFacebookFormTriggersToWidgetTriggers,
  mapFacebookWidgetTriggersToFormTriggers
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/index.js